
import { MainLayout } from "@/components/layout/MainLayout";

export default function CoursesInteractive() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Διαδραστικά Μαθήματα</h1>
        <p className="text-muted-foreground mb-6">
          Εδώ θα βρείτε όλα τα διαδραστικά μαθήματα με ασκήσεις και παραδείγματα.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="border rounded-lg p-5 hover:shadow-md transition-shadow">
              <div className="h-3 w-full bg-primary/20 rounded-full mb-4">
                <div className="h-3 bg-primary rounded-full" style={{ width: `${i * 15}%` }}></div>
              </div>
              <h3 className="font-semibold mb-1">Διαδραστικό Μάθημα {i}</h3>
              <p className="text-xs text-muted-foreground mb-3">Ενότητες: 8 • Ασκήσεις: 12</p>
              <p className="text-sm text-muted-foreground mb-3">
                Περιγραφή του διαδραστικού μαθήματος και του περιεχομένου του.
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium">20 Credits</span>
                <button className="text-primary text-sm hover:underline">Συνέχεια</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
